module.exports = __webpack_public_path__ + "static/media/High-end-all-in-one-dual-screen.e6106838.png";